/** @format */
import { css } from 'styled-components';

import { safeObjectFit } from '@toucan/client/global/application';

export const styles = css`
    touch-action: pinch-zoom pan-y;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    user-select: none;

    img {
        ${safeObjectFit('contain')}
    }
`;
